module.exports = __webpack_public_path__ + "img/menu-blue.998b5e7a.png";